import type { Catalogue } from "../i18n";

export const QC: Catalogue = {
  "failed": "échoué",
  "saving": "enregistrement",
  "waiting": "en attente",
  "today": "aujourd'hui",
  "yesterday": "hier",
  "{days}d": "{days} j",
  "{weeks}w": "{weeks} sem",
  "unlabeled": "sans nom",
  "untagged": "sans tag",
  "loading more": "chargement de la suite",
  "that's all {count}": "c'est tout, {count}",
  "shuffled": "mélangé",
  "nothing to show": "rien à montrer",
  "chi is looking again": "chi regarde de nouveau",
  "chi is looking at this one next": "chi regarde celle-ci juste après",
  "could not index that ref": "impossible d'indexer cette réf",
  "details": "détails",
  "clips are not described, write your own": "les clips ne sont pas décrits, écris la tienne",
  "chi left this one ({reason}), write your own": "chi a laissé celle-ci ({reason}), écris la tienne",
  "chi is looking at this…": "chi regarde ça…",
  "not described yet, write your own or tap spark": "pas encore décrite, écris la tienne ou touche l'étincelle",
  "saved": "enregistré",
  "could not save the description": "impossible d'enregistrer la description",
  "chi skips clips": "chi saute les clips",
  "described": "décrite",
  "chi is looking": "chi regarde",
  "skipped": "sautée",
  "waiting on chi": "en attente de chi",
  "tagging {done}/{total} · {left} left": "tagging {done}/{total} · {left} restantes",
  "tagged {done}/{total} · {left} left": "taguées {done}/{total} · {left} restantes",
  "all {total} tagged": "les {total} sont taguées",
  "{shown} of {total}": "{shown} de {total}",
  "{count} adding": "{count} en ajout",
  "{count} failed": "{count} échouées",
  "{count} to describe": "{count} à décrire",
  "busy": "occupée",
  "tag": "tag",
  "tap + to add pictures, drop files here, or use + ref in chrome": "touche + pour ajouter des images, dépose des fichiers ici ou utilise + réf dans chrome",
  "every ref already has your note": "toutes les réfs ont déjà ta note",
  "nothing matches": "rien ne correspond",
  "could not load references": "impossible de charger les références",
  "video": "vidéo",
  "all described": "tout est décrit",
  "could not read that file": "impossible de lire ce fichier",
  "nothing usable there": "rien d'utilisable là-dedans",
  "adding {count}": "ajout de {count}",
  "could not import that file": "impossible d'importer ce fichier",
  "showing {tag}": "affichage de {tag}",
  "chi is tagging {count} refs": "chi tague {count} réfs",
  "every ref is tagged": "toutes les réfs sont taguées",
  "could not start tagging": "impossible de démarrer le tagging",
  "delete this reference?": "supprimer cette référence?",
  "ref saved": "réf enregistrée",
  "ref save failed": "échec de l'enregistrement de la réf",
  "tagging done": "tagging terminé",
  "mode": "mode",
  "tools": "outils",
  "Tools": "Outils",
  "Talk to Chi": "Parler à Chi",
  "mode tuner, drag or tap a station": "syntoniseur de mode, glisse ou touche une station",
  "Tool": "Outil",
  "Chi · direct line": "Chi · ligne directe",
  "{name}'s {what} · read only": "{what} de {name} · lecture seule",
  "could not open a print sheet": "impossible d'ouvrir une feuille d'impression",
  "never": "jamais",
  "could not shrink that picture": "impossible de réduire cette image",
  "could not read that picture": "impossible de lire cette image",
  "chix is processing": "chix est en train de traiter",
  "What should I work on next?": "Sur quoi je devrais travailler ensuite?",
  "nothing yet": "rien pour l'instant",
  "where it came from": "d'où ça vient",
  "rent, phone…": "loyer, cellulaire…",
  "what was it": "c'était quoi",
  "mine": "le mien",
  "{name}'s": "de {name}",
  "added to {name}'s budget": "ajouté au budget de {name}",
  "added to your budget": "ajouté à ton budget",
  "couldn't add that": "impossible d'ajouter ça",
  "login with discord": "connexion avec discord",
  "minipi #{id}": "minipi nº {id}",
  "a minipi": "un minipi",
  "{who} says": "{who} dit",
  "{who} · art tip": "{who} · truc d'art",
  "pings": "rappels",
  "Late shift, {name}.": "Quart de nuit, {name}.",
  "Morning, {name}.": "Bonjour, {name}.",
  "Ready when you are, {name}.": "Prête quand tu l'es, {name}.",
  "Evening, {name}.": "Bonsoir, {name}.",
  "signal": "signal",
  "sweet": "sucré",
  "edge": "tranchant",
  "dark fog, film grain and chi's cyan": "brouillard sombre, grain de pellicule et le cyan de chi",
  "pale daytime fog, ink and deep teal": "brouillard pâle de jour, encre et sarcelle profond",
  "silent hill ash and an orange coal": "cendre de silent hill et une braise orange",
  "deep water, teal fog, a sonar ping": "eau profonde, brouillard sarcelle, un ping de sonar",
  "rose paper and a hot pink signal": "papier rose et un signal rose vif",
  "peach cream and a coral signal": "crème de pêche et un signal corail",
  "mint milk with strawberry pink": "lait à la menthe avec du rose fraise",
  "magical girl night, violet fog, bubblegum pink": "nuit de fille magique, brouillard violet, rose gomme balloune",
  "midnight sky in periwinkle and pink": "ciel de minuit en pervenche et rose",
  "the otherworld: rust black and blood red": "l'autre monde : noir rouille et rouge sang",
  "night city chrome, warning yellow, red glitch": "chrome de ville de nuit, jaune d'alerte, glitch rouge",
  "bruise purple fog and acid lime": "brouillard mauve bleuet et lime acide",
  "pure black and white, no mercy": "noir et blanc pur, sans pitié",
  "green crt, memory card manager at 2am": "crt vert, gestionnaire de carte mémoire à 2 h du matin",
  "amber crt terminal, warm glow": "terminal crt ambre, lueur chaude",
  "cream sketch paper and flipnote orange": "papier à croquis crème et orange flipnote",
  "grey console, blue memory card screen": "console grise, écran bleu de carte mémoire",
  "four shades of handheld green": "quatre teintes de vert de portable",
  "none": "aucun",
  "scanlines": "lignes de balayage",
  "grid": "quadrillage",
  "dots": "points",
  "notebook": "cahier",
  "checker": "damier",
  "crosshair": "réticule",
  "sparkles": "étincelles",
  "hazard": "danger",
  "starry sky": "ciel étoilé",
  "falling leaves": "feuilles qui tombent",
  "sakura petals": "pétales de sakura",
  "snow": "neige",
  "rain": "pluie",
  "fireflies": "lucioles",
  "moves gently, stays still with calm motion": "bouge doucement, reste immobile avec mouvement calme",
  "pattern on": "motif activé",
  "theme on": "thème activé",
  "saved, type to replace": "enregistrée, écris pour remplacer",
  "not set": "non configuré",
  "token copied": "jeton copié",
  "make a new extension token? the old one stops working until you paste the new one in": "créer un nouveau jeton d'extension? l'ancien arrête de fonctionner tant que tu n'as pas collé le nouveau",
  "new token made": "nouveau jeton créé",
  "log out of chix on every device?": "fermer la session chix sur tous les appareils?",
  "$ dollar": "$ dollar",
  "£ pound": "£ livre",
  "C$ canadian": "C$ canadien",
  "A$ australian": "A$ australien",
  "CHF swiss franc": "CHF franc suisse",
  "talking to plane": "communication avec plane",
  "connected to {workspace}, now pick your boards": "connecté à {workspace}, choisis maintenant tes tableaux",
  "open plane": "ouvrir plane",
  "in safari, create an api token in profile settings, paste it below, then save": "dans safari, crée un jeton d'api dans les réglages du profil, colle-le ci-dessous, puis enregistre",
  "couldn't do that": "impossible de faire ça",
  "google turned the map key away. check it's allowed on this site and maps javascript api is on": "google a refusé la clé de la carte. vérifie qu'elle est permise sur ce site et que maps javascript api est activée",
  "the map needs a key to draw, searches and routes still work below": "la carte a besoin d'une clé pour s'afficher, les recherches et les trajets fonctionnent quand même plus bas",
  "the map couldn't load. searches and routes still work below": "la carte n'a pas pu se charger. les recherches et les trajets fonctionnent quand même plus bas",
  "you": "toi",
  "new pin": "nouvelle épingle",
  "open now": "ouvert maintenant",
  "closed now": "fermé maintenant",
  "new": "nouveau",
  "{rating} from 1 review": "{rating} sur 1 avis",
  "{rating} from {count} reviews": "{rating} sur {count} avis",
  "no reviews yet": "aucun avis pour l'instant",
  "no parking info": "aucune info de stationnement",
  "no parking listed": "aucun stationnement indiqué",
  "{place} is stop {letter}": "{place} est l'arrêt {letter}",
  "save": "enregistrer",
  "looking…": "recherche…",
  "nothing found there. try further out or other words": "rien trouvé là. essaie plus loin ou d'autres mots",
  "pick something to look for, or search above": "choisis quelque chose à chercher, ou cherche plus haut",
  "{what} within {distance} of {place}": "{what} dans un rayon de {distance} de {place}",
  "around {place}": "autour de {place}",
  "ten stops is the most": "dix arrêts, c'est le maximum",
  "taken out of saved": "retiré des enregistrés",
  "remove {name}?": "retirer {name}?",
  "nothing saved yet": "rien d'enregistré pour l'instant",
  "tap the map": "touche la carte",
  "drop a pin": "poser une épingle",
  "edit {name}": "modifier {name}",
  "save pin": "enregistrer l'épingle",
  "my pin": "mon épingle",
  "pinned": "épinglé",
  "places, ratings, parking and routes come from google maps. it needs a key from your google cloud account, google gives a free allowance each month": "les lieux, les évaluations, le stationnement et les trajets viennent de google maps. ça prend une clé de ton compte google cloud, google offre un quota gratuit chaque mois",
  "fractal hasn't added a google maps key yet, so the map can't look anything up": "fractal n'a pas encore ajouté de clé google maps, donc la carte ne peut rien chercher",
  "within {distance}": "dans un rayon de {distance}",
  "this area": "ce secteur",
  "couldn't find where you are, staying around {place}": "impossible de trouver où tu es, on reste autour de {place}",
  "cyan": "cyan",
  "violet": "violet",
  "amber": "ambre",
  "green": "vert",
  "red": "rouge",
  "tap the map where the pin goes": "touche la carte là où va l'épingle",
  "couldn't find where you are": "impossible de trouver où tu es",
  "take this pin off the map?": "retirer cette épingle de la carte?",
  "where i am": "où je suis",
  "home ({place})": "maison ({place})",
  "name this route": "donne un nom à ce trajet",
  "{from} to {to}": "{from} à {to}",
  "route saved": "trajet enregistré",
  "food": "bouffe",
  "pubs and bars": "pubs et bars",
  "takeaway": "pour emporter",
  "shops": "magasins",
  "fuel": "essence",
  "parking": "stationnement",
  "pharmacy": "pharmacie",
  "parks": "parcs",
  "things to see": "choses à voir",
  "cinema": "cinéma",
  "ev charging": "recharge de véhicules électriques",
  "drive": "char",
  "walk": "à pied",
  "cycle": "vélo",
  "bus/train": "bus/train",
  "{amount} a month": "{amount} par mois",
  "by {date}": "d'ici le {date}",
  "monthly, stopped {date}": "mensuel, arrêté le {date}",
  "monthly from {date}": "mensuel depuis le {date}",
  "on {date}": "le {date}",
  "added by you": "ajouté par toi",
  "added by {name}": "ajouté par {name}",
  "{done} paid of {total} · {left} left": "{done} payé sur {total} · reste {left}",
  "paid off · {total}": "entièrement payé · {total}",
  "{done} saved of {total} · {left} to go": "{done} épargné sur {total} · reste {left}",
  "reached · {done}": "atteint · {done}",
  "in": "entrées",
  "bill": "facture",
  "cost": "dépense",
  "debt": "dette",
  "goal": "objectif",
  "remove {name}? its history goes too": "retirer {name}? son historique part aussi",
  "restart": "redémarrer",
  "stop": "arrêter",
  "paid": "payé",
  "payment logged": "paiement noté",
  "saved toward it": "épargné pour ça",
  "took back the last one": "le dernier a été annulé",
  "{amount} left": "reste {amount}",
  "{amount} saved": "{amount} épargnés",
  "out": "sorties",
  "no monthly bills yet": "aucune facture mensuelle pour l'instant",
  "owe": "je dois",
  "{percent}% of {total}": "{percent} % de {total}",
  "{amount} this month": "{amount} ce mois-ci",
  "owed in total": "dû au total",
  "target": "cible",
  "a month (optional)": "par mois (facultatif)",
  "how much comes in": "combien rentre",
  "how much": "combien",
  "by": "d'ici le",
  "since": "depuis",
  "from": "depuis",
  "on": "le",
  "where it comes from": "d'où ça vient",
  "rent, phone, adobe…": "loyer, cellulaire, adobe…",
  "what you bought": "ce que tu as acheté",
  "who or what you owe": "à qui ou quoi tu dois",
  "what you're saving for": "pour quoi tu épargnes",
  "add": "ajouter",
  "add to the budget": "ajouter au budget",
  "added": "ajouté",
  "couldn't save that": "impossible d'enregistrer ça",
  "due: {title}": "échéance : {title}",
  "unexpected \"{char}\"": "« {char} » inattendu",
  "missing )": "il manque )",
  "expected a number": "un nombre était attendu",
  "that goes to infinity": "ça tend vers l'infini",
  "not set, add it in setup": "non configurée, ajoute-la dans les réglages",
  "{spent} of {budget} for tagging": "{spent} sur {budget} pour le tagging",
  "no cap on tagging": "aucune limite pour le tagging",
  "{count} refs waiting since {time}": "{count} réfs en attente depuis {time}",
  "none running": "aucun en cours",
  "{calls} calls · {input} in · {cached} cached · {output} out": "{calls} appels · {input} en entrée · {cached} en cache · {output} en sortie",
  "nothing yet for {month}": "rien pour l'instant en {month}",
  "{calls} calls": "{calls} appels",
  "split starts with the next answer": "la répartition commence avec la prochaine réponse",
  "could not read claude usage": "impossible de lire l'utilisation de claude",
  "all": "tout",
  "start {name}?": "démarrer {name}?",
  "starting {name}...": "démarrage de {name}...",
  "{name} start sent": "démarrage de {name} envoyé",
  "stop {name}?": "arrêter {name}?",
  "stopping {name}...": "arrêt de {name}...",
  "{name} stop sent": "arrêt de {name} envoyé",
  "restart {name}?": "redémarrer {name}?",
  "restarting {name}...": "redémarrage de {name}...",
  "{name} restart sent": "redémarrage de {name} envoyé",
  "running": "en marche",
  "stopped": "arrêté",
  "crash looping": "plante en boucle",
  "starting": "démarrage",
  "up {time}": "actif depuis {time}",
  "{count} restarts": "{count} redémarrages",
  "{name} logs": "journaux de {name}",
  "loading...": "chargement...",
  "{used} of {total}": "{used} sur {total}",
  "could not reach the server: {error}": "impossible de joindre le serveur : {error}",
  "validating caddy...": "validation de caddy...",
  "caddy reloaded": "caddy rechargé",
  "{label}, one per line": "{label}, un par ligne",
  "change picture": "changer l'image",
  "all {n}": "tout {n}",
  "unsorted": "non classé",
  "under a cent": "moins d'un cent",
  "chi looking {done}/{total}": "chi regarde {done}/{total}",
  "chi look {done}/{total}": "chi regarde {done}/{total}",
  "chi looked": "chi a regardé",
  "chi has looked at every character picture": "chi a regardé toutes les images de personnages",
  "{n} more wait for another press.": "{n} autres attendent une prochaine pression.",
  "chi has looked at {done} of {total} character pictures. look at the next {count} for about {price}? it goes through the half price batch, so it can take a while.": "chi a regardé {done} images de personnages sur {total}. regarder les {count} suivantes pour environ {price}? ça passe par le lot à moitié prix, donc ça peut prendre du temps.",
  "chi is looking at {count} pictures": "chi regarde {count} images",
  "could not start chi": "impossible de démarrer chi",
  "chi looks at 1 picture of {name} she hasn't seen, about {price}?": "chi regarde 1 image de {name} qu'elle n'a pas vue, pour environ {price}?",
  "chi looks at {count} pictures of {name} she hasn't seen, about {price}?": "chi regarde {count} images de {name} qu'elle n'a pas vues, pour environ {price}?",
  "chi has seen all {total} pictures of {name}. look at them again from scratch, about {price}?": "chi a vu les {total} images de {name}. les regarder de nouveau à partir de zéro, pour environ {price}?",
  "chi is looking at {name}": "chi regarde {name}",
  "picture {n}": "image {n}",
  "adding 1 picture…": "ajout de 1 image…",
  "adding {n} pictures…": "ajout de {n} images…",
  "picture added": "image ajoutée",
  "{n} pictures added": "{n} images ajoutées",
  "could not add the picture": "impossible d'ajouter l'image",
  "take this picture off the character?": "retirer cette image du personnage?",
  "picture removed": "image retirée",
  "could not remove the picture": "impossible de retirer l'image",
  "sheet picture changed": "image de la fiche changée",
  "could not change the picture": "impossible de changer l'image",
  "fetching characters from {source}…": "récupération des personnages depuis {source}…",
  "{n} found": "{n} trouvés",
  "{n} added": "{n} ajoutés",
  "{n} updated": "{n} mis à jour",
  "{n} duplicates merged": "{n} doublons fusionnés",
  "{n} failed": "{n} échoués",
  "{source} import failed": "l'importation de {source} a échoué",
  "aka {names}": "alias {names}",
  "{n} pictures": "{n} images",
  "merge into {name}": "fusionner avec {name}",
  "merge {other} into {name}? {other}'s sheet goes away and its pictures move to {name}.": "fusionner {other} avec {name}? la fiche de {other} disparaît et ses images passent à {name}.",
  "{other} merged into {name}": "{other} fusionné avec {name}",
  "the sheet": "la fiche",
  "could not merge": "impossible de fusionner",
  "character saved": "personnage enregistré",
  "could not save": "impossible d'enregistrer",
  "delete {name}?": "supprimer {name}?",
  "1 block today": "1 bloc aujourd'hui",
  "{n} blocks today": "{n} blocs aujourd'hui",
  "resume": "reprendre",
  "back to drawing": "retour au dessin",
  "break time, stretch your hand": "c'est la pause, étire ta main",
  "focus block started": "bloc de concentration démarré",
  "take a break": "prends une pause",
  "type minutes, like 40 or 1h30": "écris des minutes, comme 40 ou 1h30",
  "drop this picture": "enlever cette image",
  "toss {hex}?": "jeter {hex}?",
  "copied {hex}": "{hex} copié",
  "prompt copied": "prompt copié",
  "commissions": "commandes",
  "no commissions": "aucune commande",
  "comms money": "argent des commandes",
  "{n} paid": "{n} payées",
  "{n} others": "{n} autres",
  "nothing paid yet": "rien de payé pour l'instant",
  "that task is done or gone": "cette tâche est terminée ou n'existe plus",
  "unlink {title}": "dissocier {title}",
  "no task matches": "aucune tâche ne correspond",
  "no open tasks. add one in tasks first": "aucune tâche ouverte. ajoute-en une dans tâches d'abord",
  "for {client}": "pour {client}",
  "paid {day}": "payé {day}",
  "due {date}": "échéance {date}",
  "commission saved": "commande enregistrée",
  "commission added": "commande ajoutée",
  "break": "pause",
  "unknown": "inconnu",
  "fapped {n} times": "fap {n} fois",
  "no doodles match": "aucun griffonnage ne correspond",
  "could not load the doodles": "impossible de charger les griffonnages",
  "no picture on the clipboard": "aucune image dans le presse-papiers",
  "pick a picture": "choisis une image",
  "you can look at the doodles, not add them": "tu peux regarder les griffonnages, pas en ajouter",
  "adding the doodle": "ajout du griffonnage",
  "adding {n} of {total}": "ajout de {n} sur {total}",
  "{n} doodles added": "{n} griffonnages ajoutés",
  "could not add that": "impossible d'ajouter ça",
  "press ctrl+v or ⌘v to paste": "appuie sur ctrl+v ou ⌘v pour coller",
  "couldn't read the clipboard, try ctrl+v or ⌘v": "impossible de lire le presse-papiers, essaie ctrl+v ou ⌘v",
  "gone": "disparu",
  "remove {name}": "retirer {name}",
  "new doodle": "nouveau griffonnage",
  "doodle saved": "griffonnage enregistré",
  "delete this doodle?": "supprimer ce griffonnage?",
  "could not delete": "impossible de supprimer",
  "by {name}": "par {name}",
  "one a day per doodle, come back tomorrow": "un par jour par griffonnage, reviens demain",
  "today ✓ {n}": "aujourd'hui ✓ {n}",
  "fapped {n}×": "fap {n}×",
  "you {n}": "toi {n}",
  "could not count that": "impossible de compter ça",
  "random full body poses from the pocketbase library": "poses de corps entier au hasard de la bibliothèque pocketbase",
  "{n} refs in the pool": "{n} réfs dans le bassin",
  "no refs match yet": "aucune réf ne correspond pour l'instant",
  "could not fetch poses": "impossible de récupérer les poses",
  "play": "reprendre",
  "no poses to draw from": "aucune pose où piger",
  "{n} poses done, nice": "{n} poses faites, bravo",
  "{n} answered today": "{n} répondues aujourd'hui",
  "{n} day streak": "série de {n} jours",
  "nothing due right now, {n} learning cards come back in {minutes}m": "rien à réviser pour l'instant, {n} cartes en apprentissage reviennent dans {minutes} min",
  "today's cards are done, see you tomorrow": "les cartes d'aujourd'hui sont faites, à demain",
  "no cards to study, switch a deck on below": "aucune carte à étudier, active un paquet plus bas",
  "{seen} of {total} seen · {solid} solid": "{seen} vues sur {total} · {solid} solides",
  "study {deck}": "étudier {deck}",
  "could not load the deck": "impossible de charger le paquet",
  "could not save that answer": "impossible d'enregistrer cette réponse",
  "could not save the deck setup": "impossible d'enregistrer la configuration du paquet",
  "basics": "les bases",
  "favourites": "favoris",
  "likes and goals": "goûts et objectifs",
  "looks": "apparence",
  "identity": "identité",
  "sexuality": "sexualité",
  "story": "histoire",
  "for chi": "pour chi",
  "orientation": "orientation",
  "trivia": "anecdotes",
  "created by": "créé par",
  "world": "monde",
  "location": "lieu",
  "race": "race",
  "occupation": "occupation",
  "gender": "genre",
  "height": "taille",
  "favourite food": "plat préféré",
  "smell": "odeur",
  "pet peeve": "bête noire",
  "likes": "goûts",
  "dislikes": "dégoûts",
  "look in short": "apparence en bref",
  "body": "corps",
  "clothes": "vêtements",
  "visual features": "traits visuels",
  "speaking": "façon de parler",
  "personality": "personnalité",
  "relationships": "relations",
  "items": "objets",
  "skills": "habiletés",
  "preferences": "préférences",
  "fetishes": "fétiches",
  "sexual trivia": "anecdotes sexuelles",
  "rpg sheet": "fiche de jeu de rôle",
  "fractal's notes for chi": "notes de fractal pour chi",
  "sees your {kinds}": "voit tes {kinds}",
  "sees nothing of yours": "ne voit rien de ce qui est à toi",
  "{line}, adds to your {kinds}": "{line}, ajoute à tes {kinds}",
  "{name} can add to your {kind}": "{name} peut ajouter à tes {kind}",
  "{name} can only read your {kind}": "{name} peut seulement lire tes {kind}",
  "{name} can see your {kind}": "{name} peut voir tes {kind}",
  "{kind} hidden from {name}": "{kind} cachés à {name}",
  "{name} can see everything you can share": "{name} peut voir tout ce que tu peux partager",
  "{name} sees nothing of yours now": "{name} ne voit plus rien de ce qui est à toi",
  "share {kind} with {name}": "partager {kind} avec {name}",
  "you don't have notes, pings or anything else to share yet": "tu n'as pas encore de notes, de rappels ni rien d'autre à partager",
  "share all": "tout partager",
  "share none": "ne rien partager",
  "nobody else is in chix yet": "personne d'autre n'est encore dans chix",
  "shares their {kinds}": "partage ses {kinds}",
  "Calendar events": "Événements du calendrier",
  "Places and routes": "Lieux et trajets",
  "your sticky notes": "tes notes autocollantes",
  "reminders, alarms and timers": "rappels, alarmes et minuteries",
  "your own events on the month": "tes propres événements du mois",
  "plane and chix bot": "plane et le bot chix",
  "clients, prices, status, linked tasks and money stats": "clients, prix, statut, tâches liées et stats d'argent",
  "bills, costs, debts and goals": "factures, dépenses, dettes et objectifs",
  "what you keep up and your streaks": "ce que tu maintiens et tes séries",
  "spots and routes you saved on the map": "endroits et trajets que tu as enregistrés sur la carte",
  "Can add to it": "Peut y ajouter",
  "bills, costs, money in and payments, with their name on them. they can change only what they added": "factures, dépenses, entrées d'argent et paiements, avec leur nom dessus. ils peuvent modifier seulement ce qu'ils ont ajouté",
  "off": "non",
  "{on} of {total} on · chi {spent} of {cap}": "{on} sur {total} activés · chi {spent} sur {cap}",
  "{on} of {total} on · chi {spent}": "{on} sur {total} activés · chi {spent}",
  "{feature} off for {name}": "{feature} désactivé pour {name}",
  "{name} can view {feature}": "{name} peut voir {feature}",
  "{name} can edit {feature}": "{name} peut modifier {feature}",
  "{feature} for {name}": "{feature} pour {name}",
  "monthly chi cap, usd": "limite mensuelle de chi, usd",
  "{name}'s chi stops at {amount} a month": "le chi de {name} s'arrête à {amount} par mois",
  "no cap for {name}": "aucune limite pour {name}",
  "{spent} over {count} answers this month. 0 means no cap": "{spent} sur {count} réponses ce mois-ci. 0 veut dire aucune limite",
  "remove {name}? they get signed out. their own notes and chats stay on the server if you add them back": "retirer {name}? sa session sera fermée. ses notes et ses conversations restent sur le serveur si tu le rajoutes",
  "{name} removed": "{name} retiré",
  "just you for now": "juste toi pour l'instant",
  "{name} can sign in now. they start with chi, notes, pings and routines": "{name} peut se connecter maintenant. iel commence avec chi, les notes, les rappels et les routines",
  "Calendar and pings": "Calendrier et rappels",
  "Chi speaker": "Haut-parleur Chi",
  "Discord messages": "Messages discord",
  "Keys and server setup": "Clés et configuration du serveur",
  "their own chat and memory, on your claude account": "sa propre conversation et sa propre mémoire, sur ton compte claude",
  "the shared ref library": "la bibliothèque de réfs partagée",
  "the shared oc sheets": "les fiches d'oc partagées",
  "their own": "les siens",
  "plane and chix bot, their own": "plane et le bot chix, les siens",
  "timer, palette, prompts, comms and their money stats": "minuterie, palette, prompts, commandes et leurs stats d'argent",
  "their own bills, costs, debts and goals": "ses propres factures, dépenses, dettes et objectifs",
  "places nearby, routes and their saved spots, on your google maps key": "lieux à proximité, trajets et endroits enregistrés, avec ta clé google maps",
  "gesture drawing and japanese": "dessin gestuel et japonais",
  "the shared doodle wall": "le mur de griffonnages partagé",
  "their own scan library": "sa propre bibliothèque de numérisations",
  "their pings ring at home, chi answers their voice": "ses rappels sonnent à la maison, chi répond à sa voix",
  "chi can dm your contacts for them": "chi peut écrire en dm à tes contacts pour eux",
  "vps panel and bot controls": "panneau du vps et commandes du bot",
  "every log line": "chaque ligne de journal",
  "spend and billing": "dépenses et facturation",
  "api keys, ssh": "clés d'api, ssh",
  "this dashboard": "ce tableau de bord",
  "tap to upload": "touche pour téléverser",
  "{count} kept": "{count} gardées",
  "uploading {n} of {total}": "téléversement de {n} sur {total}",
  "scan kept": "numérisation gardée",
  "{count} scans kept": "{count} numérisations gardées",
  "upload failed": "échec du téléversement",
  "the brother is scanning": "la brother numérise",
  "scan failed": "échec de la numérisation",
  "saving {n} of {total}": "enregistrement de {n} sur {total}",
  "added to scans": "ajouté aux numérisations",
  "could not save that": "impossible d'enregistrer ça",
  "pdf scan, use download to open it": "numérisation pdf, utilise télécharger pour l'ouvrir",
  "delete this scan?": "supprimer cette numérisation?",
  "days apart": "jours d'écart",
  "times a week, any days": "fois par semaine, n'importe quels jours",
  "day of the month": "jour du mois",
  "added by another part of chix, ticked off there too": "ajoutée par une autre partie de chix, cochée là-bas aussi",
  "delete {title} and its history?": "supprimer {title} et son historique?",
  "no routines": "aucune routine",
  "ChiX routine": "Routine ChiX",
  "time for {title}": "c'est l'heure de {title}",
  "weekdays": "en semaine",
  "every {n} days": "aux {n} jours",
  "{n}x a week": "{n} fois par semaine",
  "monthly on day {day}": "chaque mois le jour {day}",
  "{done}/{times} this week": "{done}/{times} cette semaine",
  "ping {time}": "rappel {time}",
  "{n}w streak": "série de {n} sem",
  "{n} streak": "série de {n}",
  "{title} done": "{title} fait",
  "sticky {date}": "note {date}",
  "saved {time}": "enregistré {time}",
  "nothing coming up": "rien à venir",
  "edit chix task": "modifier la tâche chix",
  "new chix task": "nouvelle tâche chix",
  "saving...": "enregistrement...",
  "mark \"{title}\" as done?": "marquer « {title} » comme faite?",
  "urgent": "urgente",
  "high": "haute",
  "medium": "moyenne",
  "low": "basse",
  "{count} shown, updated {time}": "{count} affichées, mis à jour {time}",
  "nothing pending": "rien en attente",
  "night": "nuit",
  "fog": "brouillard",
  "ember": "braise",
  "abyss": "abysse",
  "petal": "pétale",
  "peach": "pêche",
  "mint": "menthe",
  "lilac": "lilas",
  "starlight": "lumière d'étoile",
  "venom": "venin",
  "pocket": "poche",
  "{title} reached, tap done to cross it off": "{title} atteint, touche fait pour le rayer",
  "delete {title}? it won't come back": "supprimer {title}? ça ne reviendra pas",
  "done · {n}": "faits · {n}",
  "no goals": "aucun objectif",
  "this one's done, saving keeps it crossed out": "celui-là est fait, enregistrer le garde rayé",
  "no goals on the go": "aucun objectif en cours",
  "add a couple of options": "ajoute quelques options",
  "last one standing: {label}": "le dernier en lice : {label}",
  "everything's been knocked out": "tout a été éliminé",
  "spinning": "ça tourne",
  "the wheel says": "la roue dit",
  "new wheel": "nouvelle roue",
  "knocked out": "éliminé",
  "{n} on the wheel, {out} knocked out": "{n} sur la roue, {out} éliminés",
  "{n} on the wheel": "{n} sur la roue",
  "just now": "à l'instant",
  "{n}m ago": "il y a {n} min",
  "{n}h ago": "il y a {n} h",
  "ready": "prêt",
  "flick the wheel or press spin": "lance la roue ou appuie sur tourner",
  "add a couple of options to spin": "ajoute quelques options pour tourner",
  "a wheel holds {max} options": "une roue contient {max} options",
  "only {room} fit, a wheel holds {max}": "seulement {room} entrent, une roue contient {max}",
  "my characters": "mes personnages",
  "there aren't enough characters yet": "il n'y a pas encore assez de personnages",
  "which oc": "quel oc",
  "{name} copy": "{name} copie",
  "delete the wheel \"{name}\"?": "supprimer la roue « {name} »?",
  "yes or no": "oui ou non",
  "what to draw": "quoi dessiner",
  "dinner": "souper",
  "dice": "dé",
  "who does it": "qui s'en occupe",
  "yes": "oui",
  "gesture warm up": "réchauffement de gestes",
  "portrait": "portrait",
  "an oc": "un oc",
  "hands and feet": "mains et pieds",
  "background": "arrière-plan",
  "comic page": "page de bd",
  "redraw an old piece": "redessiner une vieille pièce",
  "burgers": "hamburgers",
  "noodles": "nouilles",
  "cook something": "cuisiner quelque chose",
  "yellow": "jaune",
  "orange": "orange",
  "lime": "lime",
  "teal": "sarcelle",
  "blue": "bleu",
  "purple": "mauve",
  "pink": "rose",
  "white": "blanc",
  "black": "noir",
  "sky": "ciel",
  "slate": "ardoise",
  "edit message": "modifier le message",
  "delete your message? it goes for everyone": "supprimer ton message? il disparaît pour tout le monde",
  "delete {name}'s message? it goes for everyone": "supprimer le message de {name}? il disparaît pour tout le monde",
  "couldn't delete that": "impossible de supprimer ça",
  "couldn't post that": "impossible de publier ça",
  "1 message": "1 message",
  "{n} messages": "{n} messages",
  "someone": "quelqu'un",
  "edited": "modifié",
  "now": "maintenant",
  "{n}m": "{n} min",
  "{n}h": "{n} h",
  "+{n} more": "+{n} de plus",
  "couldn't switch": "impossible de changer",
  "switch": "changer",
  "profile": "profil",
  "that isn't a picture": "ce n'est pas une image",
  "picture saved": "image enregistrée",
  "upload picture": "téléverser une image",
  "use {name}'s discord picture": "utiliser l'image discord de {name}",
  "remove picture": "retirer l'image",
  "owned by": "appartient à",
  "remove {name} as an owner": "retirer {name} comme propriétaire",
  "owner removed": "propriétaire retiré",
  "another discord user id": "un autre id d'utilisateur discord",
  "discord user id": "id d'utilisateur discord",
  "add owner": "ajouter un propriétaire",
  "they can sign in as {name} now": "iels peuvent se connecter en tant que {name} maintenant",
  "a discord account that owns an alter can sign in and switch to it, so give the alter's own account here": "un compte discord qui possède un alter peut se connecter et passer à lui, alors mets ici le compte propre de l'alter",
  "she/her, they/them…": "elle, iel…",
  "a line about them": "une ligne à propos d'eux",
  "pronouns": "pronoms",
  "about": "à propos",
  "be {name}": "être {name}",
  "{name} is part of {system}": "{name} fait partie de {system}",
  "back to my profile": "retour à mon profil",
  "remove {name}? their notes and chats stay on the server if you add them back": "retirer {name}? ses notes et ses conversations restent sur le serveur si tu le rajoutes",
  "no alters yet. add the first one above": "aucun alter pour l'instant. ajoute le premier plus haut",
  "{name} added": "{name} ajouté",
  "size: {size}, change": "taille : {size}, changer",
  "small": "petite",
  "half": "moitié",
  "wide": "large",
  "hide": "cacher",
  "move earlier": "déplacer plus tôt",
  "move later": "déplacer plus tard",
  "hold to drag": "maintiens pour glisser",
  "arrange home": "organiser l'accueil",
  "ask chi": "demande à chi",
  "inbox": "boîte de réception",
  "gauges": "jauges",
  "message board": "babillard de messages",
  "spin": "tourner",
  "{n} lines": "{n} traits",
  "live": "en direct",
  "no shared boards yet. make one and everyone can draw on it together": "aucun tableau partagé pour l'instant. crées-en un et tout le monde peut y dessiner ensemble",
  "no shared boards yet. Fractal can make one": "aucun tableau partagé pour l'instant. Fractal peut en créer un",
  "{shared} shared · {mine} yours": "{shared} partagés · {mine} à toi",
  "could not load the boards": "impossible de charger les tableaux",
  "could not make a board": "impossible de créer le tableau",
  "that board was deleted": "ce tableau a été supprimé",
  "shared board": "tableau partagé",
  "board": "tableau",
  "offline, will send when back": "hors ligne, sera envoyé au retour",
  "that's someone else's, only they can change it": "ça appartient à quelqu'un d'autre, seulement cette personne peut le modifier",
  "lost the board": "tableau perdu",
  "that layer is hidden, show it to draw": "ce calque est caché, affiche-le pour dessiner",
  "that layer is hidden, show it to write": "ce calque est caché, affiche-le pour écrire",
  "that layer is locked": "ce calque est verrouillé",
  "that layer is {who}'s, ask them to let you draw on it": "ce calque est à {who}, demande-lui de te laisser y dessiner",
  "that layer has other people's lines, use the stroke eraser": "ce calque a des traits d'autres personnes, utilise la gomme à traits",
  "pencil found, fingers now move the board": "crayon détecté, les doigts déplacent maintenant le tableau",
  "{n} frames": "{n} images",
  "open": "ouvrir",
  "empty": "vide",
  "this layer is yours": "ce calque est à toi",
  "{who}'s layer": "calque de {who}",
  ", open to everyone": ", ouvert à tout le monde",
  ", only they draw here": ", seulement cette personne dessine ici",
  "frames": "images",
  "animate": "animer",
  "layer {n}": "calque {n}",
  "delete {name}? you can undo it": "supprimer {name}? tu peux annuler",
  "{name} cleared, undo brings it back": "{name} vidé, annuler le ramène",
  "{n} frames is the most a layer holds": "{n} images, c'est le maximum d'un calque",
  "delete frame {n}? you can undo it": "supprimer l'image {n}? tu peux annuler",
  "frame {n}": "image {n}",
  "frames per second": "images par seconde",
  "onion skin {state}": "pelure d'oignon {state}",
  "shared · look only": "partagé · lecture seule",
  "shared · live": "partagé · en direct",
  "private": "privé",
  "paper {color}": "papier {color}",
  "could not make the picture": "impossible de créer l'image",
  "draw something first": "dessine quelque chose d'abord",
  "posted to the doodle wall": "publié sur le mur de griffonnages",
  "could not post it": "impossible de le publier",
  "delete {name}? this can't be undone": "supprimer {name}? ça ne peut pas être annulé",
  "delete {name}? this can't be undone, and it goes for everyone": "supprimer {name}? ça ne peut pas être annulé, et ça disparaît pour tout le monde",
  "could not delete it": "impossible de le supprimer",
  "could not open that board": "impossible d'ouvrir ce tableau",
  "brush": "pinceau",
  "erase": "effacer",
  "select": "sélectionner",
  "shape": "forme",
  "text": "texte",
  "move": "déplacer",
  "line": "ligne",
  "arrow": "flèche",
  "box": "boîte",
  "ellipse": "ellipse",
  "rub out": "frotter",
  "whole strokes": "traits entiers",
  "duplicate": "dupliquer",
  "delete": "supprimer",
  "done": "fait",
  "drag to pick, tap one stroke": "glisse pour choisir, touche un trait",
  "show": "afficher",
  "lock": "verrouiller",
  "unlock": "déverrouiller",
  "move up": "monter",
  "move down": "descendre",
  "stop playing": "arrêter",
  "play this layer": "jouer ce calque",
  "previous frame": "image précédente",
  "next frame": "image suivante",
  "new empty frame": "nouvelle image vide",
  "copy this frame": "copier cette image",
  "delete this frame": "supprimer cette image",
  "move this frame earlier": "déplacer cette image plus tôt",
  "move this frame later": "déplacer cette image plus tard",
  "plain": "uni",
  "lines": "lignes",
  "pen": "stylo",
  "pencil": "crayon",
  "ink": "encre",
  "marker": "marqueur",
  "glow": "lueur",
  "eraser": "gomme",
  "water": "eau",
  "air": "air",
  "spray": "aérosol",
  "coal": "charbon",
  "chalk": "craie",
  "crayon": "crayon de cire",
  "rainbow": "arc-en-ciel",
  "glitter": "brillants",
  "neon": "néon",
  "boil": "bouillonner",
  "wave": "vague",
  "flame": "flamme",
  "march": "marche",
  "pulse": "pulsation",
  "draw": "dessin",
  "paint": "peinture",
  "texture": "texture",
  "steady": "stable",
  "pressure": "pression",
  "soft": "doux",
  "spread": "dispersion",
  "reset this brush": "réinitialiser ce pinceau",
  "multiply": "multiplier",
  "screen": "superposition d'écran",
  "overlay": "incrustation",
  "soft light": "lumière douce",
  "hard light": "lumière crue",
  "darken": "assombrir",
  "lighten": "éclaircir",
  "color dodge": "densité couleur moins",
  "color burn": "densité couleur plus",
  "difference": "différence",
  "exclusion": "exclusion",
  "Goals": "Objectifs",
  "me": "moi",
  "Profile": "Profil",
  "Message board": "Babillard de messages",
  "Roulette": "Roulette",
  "Whiteboards": "Tableaux blancs",
  "nothing on the board yet": "rien sur le babillard pour l'instant",
  "add to a": "ajouter à un",
  "default": "par défaut",
  "out of": "sur",
  "no goals yet. add one for a chapter to finish, a page count to hit or anything you're working towards": "aucun objectif pour l'instant. ajoutes-en un pour un chapitre à finir, un nombre de pages à atteindre ou tout ce vers quoi tu travailles",
  "kana is the standard gojūon table. kanji are the 2,211 jlpt n5 to n1 kanji, meanings and readings from kanjidic2 (edrdg, cc by-sa 4.0), levels from jonathan waller's jlpt lists (cc by)": "le kana est le tableau gojūon standard. les kanji sont les 2 211 kanji du jlpt n5 à n1, sens et lectures de kanjidic2 (edrdg, cc by-sa 4.0), niveaux des listes jlpt de jonathan waller (cc by)",
  "bring all back": "tout ramener",
  "slices": "pointes",
  "history": "historique",
  "options": "options",
  "pasting a list adds them all. pizza *3 makes pizza three times as likely, and the weights below set it per slice": "coller une liste les ajoute toutes. pizza *3 rend la pizza trois fois plus probable, et les poids plus bas règlent ça par pointe",
  "no options yet. add a few, or start from a preset in options": "aucune option pour l'instant. ajoutes-en quelques-unes, ou pars d'un préréglage dans options",
  "shuffle": "mélanger",
  "even odds": "chances égales",
  "theme colours": "couleurs du thème",
  "tally": "décompte",
  "last spins": "derniers tours",
  "nothing spun on this wheel yet": "cette roue n'a pas encore tourné",
  "after a spin": "après un tour",
  "keep it": "le garder",
  "knock it out": "l'éliminer",
  "knock it out takes each winner off the wheel until you bring them all back, good for turns and tournaments": "l'éliminer retire chaque gagnant de la roue jusqu'à ce que tu les ramènes tous, pratique pour les tours de rôle et les tournois",
  "spin length": "durée du tour",
  "quick": "rapide",
  "clicks and a jingle": "des clics et un jingle",
  "new wheel from": "nouvelle roue à partir de",
  "copy this wheel": "copier cette roue",
  "delete wheel": "supprimer la roue",
  "winners are picked with your device's secure random, in proportion to each slice's weight, so a slice that looks twice as big really is twice as likely": "les gagnants sont choisis avec l'aléatoire sécurisé de ton appareil, proportionnellement au poids de chaque pointe, donc une pointe qui paraît deux fois plus grosse est vraiment deux fois plus probable",
  "wheel": "roue",
  "the wheel, flick it to spin": "la roue, lance-la pour la faire tourner",
  "add options, one per line": "ajoute des options, une par ligne",
  "option": "option",
  "weight": "poids",
  "less likely": "moins probable",
  "more likely": "plus probable",
  "less": "moins",
  "more": "plus",
  "shared": "partagés",
  "new board": "nouveau tableau",
  "mine · private": "à moi · privé",
  "no boards of your own yet. only you ever see these": "aucun tableau à toi pour l'instant. toi seul les vois",
  "layers": "calques",
  "opacity": "opacité",
  "blend": "fusion",
  "let others draw on this layer": "laisser les autres dessiner sur ce calque",
  "brush ·": "pinceau ·",
  "pick from the board": "choisir sur le tableau",
  "recent": "récentes",
  "any colour": "n'importe quelle couleur",
  "paper": "papier",
  "only the pencil draws, fingers move and zoom the board": "seul le crayon dessine, les doigts déplacent et zooment le tableau",
  "fit": "ajuster",
  "save png": "enregistrer en png",
  "post to doodles": "publier dans griffonnages",
  "two fingers pinch and move, tap two fingers to undo, three to redo. on a keyboard: space drags, [ and ] size, ⌘z undo, k brushes, x erases whole strokes, t text, v select, u shapes, comma and full stop step frames, backslash plays": "deux doigts pincent et déplacent, touche à deux doigts pour annuler, à trois pour rétablir. au clavier : espace pour glisser, [ et ] pour la taille, ⌘z annuler, k pinceaux, x efface des traits entiers, t texte, v sélectionner, u formes, virgule et point changent d'image, barre oblique inversée joue",
  "delete board": "supprimer le tableau",
  "Board": "Babillard",
  "everyone on chi sees this": "tout le monde sur chi voit ça",
  "nothing on the board yet. post the first line": "rien sur le babillard pour l'instant. publie la première ligne",
  "who's here": "qui est là",
  "who is here": "qui est là",
  "jot to inbox": "noter dans la boîte de réception",
  "say something to everyone": "dis quelque chose à tout le monde",
  "message for the board": "message pour le babillard",
  "finish the chapter 2 sprites…": "finir les sprites du chapitre 2…",
  "why, or what done looks like, optional": "pourquoi, ou à quoi ressemble « terminé », facultatif",
  "progress": "progrès",
  "counting what": "compter quoi",
  "a board everyone can draw on together": "un tableau où tout le monde peut dessiner ensemble",
  "a board only you can see": "un tableau que toi seul peux voir",
  "text on the board": "texte sur le tableau",
  "back to the boards": "retour aux tableaux",
  "undo, or tap with two fingers": "annuler, ou touche à deux doigts",
  "redo": "rétablir",
  "redo, or tap with three fingers": "rétablir, ou touche à trois doigts",
  "fit the drawing on screen": "ajuster le dessin à l'écran",
  "fit to the drawing": "ajuster au dessin",
  "board settings": "réglages du tableau",
  "brush size": "taille du pinceau",
  "say something to everyone…": "dis quelque chose à tout le monde…",
  "new alter name": "nom du nouvel alter",
  "all {count} presets are taken, unpin one first": "les {count} préréglages sont pris, détache-en un d'abord",
  "could not change the owner": "impossible de changer le propriétaire",
  "description": "description",
  "groups": "groupes",
  "large": "grand",
  "layout": "disposition",
  "mine {n}": "à moi {n}",
  "owners": "propriétaires",
  "presets": "préréglages",
  "reversed": "inversé",
  "sort by": "trier par",
  "tap the star on a key to pin it. pins sit above the dock as presets": "touche l'étoile d'une touche pour l'épingler. les épinglées se placent au-dessus du dock comme préréglages",
  "unknown date": "date inconnue",
  "{name} is not yours any more": "{name} n'est plus à toi",
  "{name} is yours now": "{name} est à toi maintenant",
  "Grid": "Grille",
  "Masonry": "Mosaïque",
  "Rows": "Rangées",
  "Big grid": "Grande grille",
  "Wall": "Mur",
  "Posts": "Publications",
  "Shuffle": "Mélanger",
  "random order, rolled once while it is open": "ordre aléatoire, tiré une fois pendant que c'est ouvert",
  "Newest": "Plus récents",
  "latest saved first": "dernier enregistré en premier",
  "Oldest": "Plus anciens",
  "earliest saved first": "premier enregistré en premier",
  "Most tagged": "Plus taggés",
  "refs with the most tags first": "les réfs avec le plus de tags en premier",
  "Undescribed first": "Non décrites d'abord",
  "what has no description yet comes first": "ce qui n'a pas encore de description passe en premier",
  "By tag": "Par tag",
  "grouped under the most used tag": "regroupées sous le tag le plus utilisé",
  "By author": "Par auteur",
  "grouped A to Z": "regroupées de A à Z",
  "By month": "Par mois",
  "grouped by the month you saved them": "regroupées par le mois où tu les as enregistrées",
  "By type": "Par type",
  "stills, gifs and clips apart": "images fixes, gifs et clips séparés",
  "sign in with discord · fractal and pauline": "connexion avec discord · fractal et pauline",
  "continue with discord": "continuer avec discord",
  "use": "utiliser",
  "Ready when you are.": "Prête quand tu l'es.",
  "unit": "unité",
  "chi · online": "chi · en ligne",
  "clear": "dégagé",
  "tip of the day": "truc du jour",
  "another one": "un autre",
  "add to a budget": "ajouter à un budget",
  "every month": "chaque mois",
  "up next": "à suivre",
  "all tasks": "toutes les tâches",
  "nothing due, go draw": "rien à faire, va dessiner",
  "routines": "routines",
  "routines done for today": "routines faites pour aujourd'hui",
  "notes": "notes",
  "no notes yet": "aucune note pour l'instant",
  "Tasks": "Tâches",
  "chix task": "tâche chix",
  "Notes": "Notes",
  "note": "note",
  "scratchpad": "brouillon",
  "edit": "modifier",
  "view": "voir",
  "random": "aléatoire",
  "newest": "plus récents",
  "oldest": "plus anciens",
  "by tag": "par tag",
  "stills": "images fixes",
  "moving": "animés",
  "chi's description": "description de chi",
  "your note": "ta note",
  "ctrl+enter saves and goes next": "ctrl+entrée enregistre et passe à la suivante",
  "edit tags": "modifier les tags",
  "close": "fermer",
  "next": "suivant",
  "Chi online. What are we drawing?": "Chi en ligne. On dessine quoi?",
  "what should I work on?": "sur quoi je devrais travailler?",
  "pose refs": "réfs de poses",
  "pick an oc": "choisis un oc",
  "comms": "commandes",
  "Routines": "Routines",
  "routine": "routine",
  "every day": "tous les jours",
  "on these days": "ces jours-là",
  "every few days": "aux quelques jours",
  "times a week": "fois par semaine",
  "once a month": "une fois par mois",
  "mon": "lun",
  "tue": "mar",
  "wed": "mer",
  "thu": "jeu",
  "fri": "ven",
  "sat": "sam",
  "sun": "dim",
  "ping at": "rappel à",
  "paused": "en pause",
  "cancel": "annuler",
  "nothing on today": "rien aujourd'hui",
  "other days": "autres jours",
  "no routines yet. add one for a daily sketch, a weekly stream or anything you want to keep up": "aucune routine pour l'instant. ajoutes-en une pour un croquis quotidien, un stream hebdomadaire ou tout ce que tu veux maintenir",
  "Pings": "Rappels",
  "reminder": "rappel",
  "alarm": "alarme",
  "timer": "minuterie",
  "once": "une fois",
  "daily": "quotidien",
  "weekly": "hebdomadaire",
  "set": "régler",
  "no pings yet. set one for a stream, a deadline or a break": "aucun rappel pour l'instant. règle-en un pour un stream, une date de tombée ou une pause",
  "Session": "Séance",
  "focus": "concentration",
  "start": "démarrer",
  "tap the time to type your own, like 40 or 1h30": "touche l'heure pour écrire la tienne, comme 40 ou 1h30",
  "0 blocks today": "0 bloc aujourd'hui",
  "Palette": "Palette",
  "keep": "garder",
  "tap a swatch to copy it, hold to toss it": "touche une couleur pour la copier, maintiens pour la jeter",
  "save prompt": "enregistrer le prompt",
  "tap a card to copy the whole prompt": "touche une carte pour copier tout le prompt",
  "Comms": "Commandes",
  "tap a commission to edit it": "touche une commande pour la modifier",
  "list": "liste",
  "money": "argent",
  "new commission": "nouvelle commande",
  "sketch": "croquis",
  "wip": "en cours",
  "review": "révision",
  "reference pics": "images de référence",
  "this month": "ce mois-ci",
  "this year": "cette année",
  "to be paid": "à recevoir",
  "paid by month": "payé par mois",
  "by client": "par client",
  "by status": "par statut",
  "a commission counts on the day it was marked paid. change that day on its card": "une commande compte le jour où elle a été marquée payée. change ce jour sur sa carte",
  "Budget": "Budget",
  "left": "reste",
  "in and out": "entrées et sorties",
  "monthly by category": "mensuel par catégorie",
  "debts and goals": "dettes et objectifs",
  "one off": "ponctuel",
  "monthly": "mensuel",
  "bills": "factures",
  "costs": "dépenses",
  "debts": "dettes",
  "goals": "objectifs",
  "nothing here yet. add a bill, a debt or a goal above": "rien ici pour l'instant. ajoute une facture, une dette ou un objectif plus haut",
  "only you see this unless you switch it on for someone in sharing. paid commissions count as money in": "toi seul vois ça, à moins de l'activer pour quelqu'un dans partage. les commandes payées comptent comme entrées d'argent",
  "Gesture": "Geste",
  "timed poses, draw fast, the next one drops in on its own": "poses chronométrées, dessine vite, la suivante arrive toute seule",
  "source": "source",
  "full body": "corps entier",
  "my refs": "mes réfs",
  "each pose": "chaque pose",
  "pause": "pause",
  "skip": "passer",
  "Japanese": "Japonais",
  "learning": "apprentissage",
  "show answer": "voir la réponse",
  "again": "encore",
  "hard": "difficile",
  "good": "bien",
  "easy": "facile",
  "space shows the answer, 1 to 4 grades it": "espace montre la réponse, 1 à 4 la note",
  "decks": "paquets",
  "new cards a day": "nouvelles cartes par jour",
  "study, new cards come in this order": "étude, les nouvelles cartes arrivent dans cet ordre",
  "Characters": "Personnages",
  "chi look": "regard de chi",
  "no characters match": "aucun personnage ne correspond",
  "new character": "nouveau personnage",
  "name": "nom",
  "tags, comma separated": "tags, séparés par des virgules",
  "sheet picture": "image de la fiche",
  "character file": "fichier du personnage",
  "chi saw": "chi a vu",
  "use as picture": "utiliser comme image",
  "add pic": "ajouter une image",
  "drop pic": "enlever l'image",
  "merge": "fusionner",
  "merge into": "fusionner avec",
  "pick the same character under another name. its pictures and anything this sheet is missing move here, and imports will update this sheet from then on.": "choisis le même personnage sous un autre nom. ses images et tout ce qui manque à cette fiche passent ici, et les importations mettront à jour cette fiche par la suite.",
  "Calendar": "Calendrier",
  "Maps": "Cartes",
  "near me": "près de moi",
  "maps needs a google key": "cartes a besoin d'une clé google",
  "in console.cloud.google.com make a project and turn on billing": "dans console.cloud.google.com, crée un projet et active la facturation",
  "turn on": "active",
  "and": "et",
  "make an api key under credentials, and limit it to those three apis": "crée une clé d'api sous identifiants et limite-la à ces trois api",
  "paste it in setup, keys, google maps. or put it on the server as GOOGLE_MAPS_API_KEY": "colle-la dans réglages, clés, google maps. ou mets-la sur le serveur sous GOOGLE_MAPS_API_KEY",
  "open setup": "ouvrir les réglages",
  "search this area": "chercher dans ce secteur",
  "route here": "trajet jusqu'ici",
  "route from": "trajet depuis",
  "remove": "retirer",
  "nearby": "à proximité",
  "route": "trajet",
  "best rated": "mieux notés",
  "most reviews": "plus d'avis",
  "closest": "plus proches",
  "parking first": "stationnement d'abord",
  "add where you start and where you're going. places from nearby can go in with their route button": "ajoute ton point de départ et ta destination. les lieux à proximité peuvent s'ajouter avec leur bouton de trajet",
  "from here": "à partir d'ici",
  "home": "maison",
  "best order for the middle stops": "meilleur ordre pour les arrêts du milieu",
  "plan route": "planifier le trajet",
  "time": "durée",
  "distance": "distance",
  "stops": "arrêts",
  "pins": "épingles",
  "tap drop a pin, then tap the map where it goes": "touche poser une épingle, puis touche la carte là où elle va",
  "pin where i am": "épingler où je suis",
  "places": "lieux",
  "star a place from nearby to keep it here": "mets une étoile à un lieu à proximité pour le garder ici",
  "routes": "trajets",
  "plan a route and save it to keep it here": "planifie un trajet et enregistre-le pour le garder ici",
  "only you see these unless you switch places and routes on for someone in sharing": "toi seul vois ça, à moins d'activer lieux et trajets pour quelqu'un dans partage",
  "tape": "ruban",
  "Scans": "Numérisations",
  "photo": "photo",
  "scan": "numériser",
  "on this pc": "sur ce pc",
  "upload all": "tout téléverser",
  "scans the brother left in the inbox folder that the web cannot see yet": "numérisations que la brother a laissées dans le dossier de réception et que le web ne voit pas encore",
  "no scans yet. scan on the pc, or snap a photo of a sketch": "aucune numérisation pour l'instant. numérise sur le pc, ou prends un croquis en photo",
  "Doodles": "Griffonnages",
  "paste": "coller",
  "no doodles yet. paste one, or add pictures from your phone": "aucun griffonnage pour l'instant. colles-en un, ou ajoute des images depuis ton cellulaire",
  "doodle": "griffonnage",
  "title": "titre",
  "drawn by": "dessiné par",
  "day": "jour",
  "characters in it": "personnages dedans",
  "undo mine": "annuler le mien",
  "newer": "plus récent",
  "older": "plus ancien",
  "Server": "Serveur",
  "reload caddy": "recharger caddy",
  "memory": "mémoire",
  "load": "charge",
  "bots up": "bots actifs",
  "Logs": "Journaux",
  "nothing happened yet, it shows up here live": "rien ne s'est passé pour l'instant, ça apparaît ici en direct",
  "billing": "facturation",
  "month": "mois",
  "tags": "tags",
  "key": "clé",
  "tagging": "tagging",
  "budget": "budget",
  "batch": "lot",
  "by model": "par modèle",
  "by person": "par personne",
  "estimates from the token counts claude sends back. billing has the real bill": "estimations selon le nombre de jetons que claude renvoie. la facturation a la vraie facture",
  "People": "Personnes",
  "let in": "laisser entrer",
  "their chi": "leur chi",
  "yours": "à toi",
  "everyone talks to chi on your claude key. they never see it, their chats and memory stay their own, and their share of the bill is counted here": "tout le monde parle à chi avec ta clé claude. ils ne la voient jamais, leurs conversations et leur mémoire restent à eux, et leur part de la facture est comptée ici",
  "let someone in": "laisser entrer quelqu'un",
  "they sign in with discord. if they try before you add them, the page shows them their id to send you": "ils se connectent avec discord. s'ils essaient avant que tu les ajoutes, la page leur montre leur id à t'envoyer",
  "only you": "juste toi",
  "Sharing": "Partage",
  "pick what each person can see. they can only read it, never change it. it shows up next to their own notes, pings and the rest, and their chi can read it too": "choisis ce que chaque personne peut voir. elle peut seulement le lire, jamais le modifier. ça apparaît à côté de ses propres notes, rappels et le reste, et son chi peut aussi le lire",
  "shared with you": "partagé avec toi",
  "nobody shares anything with you yet": "personne ne partage encore rien avec toi",
  "Setup": "Réglages",
  "assistant": "assistant",
  "anthropic api key": "clé d'api anthropic",
  "chat model": "modèle de clavardage",
  "ref tagging model": "modèle de tagging des réfs",
  "monthly tagging budget, usd": "budget mensuel de tagging, usd",
  "tagging pauses once the month's estimate passes the budget. 0 means no cap. claude-haiku-4-5 tags cheaper": "le tagging se met en pause quand l'estimation du mois dépasse le budget. 0 veut dire aucune limite. claude-haiku-4-5 tague à meilleur prix",
  "currency": "devise",
  "yours only. the sign shown on comms, money stats and the budget. auto reads it from what you type on commissions. it saves as soon as you pick": "juste à toi. le symbole affiché sur les commandes, les stats d'argent et le budget. auto le lit à partir de ce que tu écris dans les commandes. ça s'enregistre dès que tu choisis",
  "log into the plane tab, then connect": "connecte-toi dans l'onglet plane, puis connecte",
  "open plane, make an api token in profile settings, paste it here": "ouvre plane, crée un jeton d'api dans les réglages du profil, colle-le ici",
  "connect plane": "connecter plane",
  "workspace slug": "slug de l'espace de travail",
  "api key": "clé d'api",
  "load boards": "charger les tableaux",
  "chix bot": "bot chix",
  "api url": "url de l'api",
  "your discord user id": "ton id d'utilisateur discord",
  "browser key, optional": "clé de navigateur, facultatif",
  "the api key searches places and plans routes from the server. the map itself loads with the browser key if there is one, otherwise the api key. GOOGLE_MAPS_API_KEY on the server wins over this": "la clé d'api cherche des lieux et planifie des trajets depuis le serveur. la carte elle-même se charge avec la clé de navigateur s'il y en a une, sinon avec la clé d'api. GOOGLE_MAPS_API_KEY sur le serveur a priorité",
  "server": "serveur",
  "bots folder": "dossier des bots",
  "sudo password": "mot de passe sudo",
  "ssh host": "hôte ssh",
  "ssh user": "utilisateur ssh",
  "ssh key file": "fichier de clé ssh",
  "browser extension": "extension de navigateur",
  "paste this into the extension options as the cloud token. it's yours, so saves land as you": "colle ça dans les options de l'extension comme jeton du nuage. il est à toi, donc ce qui est enregistré est à ton nom",
  "chrome: unzip over the old folder and hit reload in chrome://extensions. firefox: open the file in firefox and allow it, it updates itself after that": "chrome : décompresse par-dessus l'ancien dossier et clique sur recharger dans chrome://extensions. firefox : ouvre le fichier dans firefox et autorise-le, il se met à jour tout seul ensuite",
  "your extension token": "ton jeton d'extension",
  "copy": "copier",
  "new token": "nouveau jeton",
  "links": "liens",
  "one per line as name | url. they open inside the desk app, or in a new tab on the web": "un par ligne sous la forme nom | url. ils s'ouvrent dans l'app de bureau, ou dans un nouvel onglet sur le web",
  "desk": "bureau",
  "cloud url": "url du nuage",
  "cloud token": "jeton du nuage",
  "chrome extension token": "jeton de l'extension chrome",
  "brother scan folder": "dossier de numérisation brother",
  "start with windows": "démarrer avec windows",
  "security": "sécurité",
  "signs out every phone, tablet and browser that is logged in, including this one. use it if a device was lost or you think someone got in": "ferme la session sur tous les cellulaires, tablettes et navigateurs connectés, celui-ci inclus. utilise ça si tu as perdu un appareil ou si tu penses que quelqu'un est entré",
  "log out everywhere": "fermer la session partout",
  "pick a look": "choisis une apparence",
  "background pattern": "motif d'arrière-plan",
  "film grain and fog": "grain de pellicule et brouillard",
  "calm motion": "mouvement calme",
  "retry": "réessayer",
  "toss": "jeter",
  "logs": "journaux",
  "paid on": "payé le",
  "undo": "annuler",
  "setup token": "jeton de configuration",
  "talk to chi": "parler à chi",
  "jot into inbox": "noter dans la boîte de réception",
  "whose budget": "budget de qui",
  "what kind": "quel genre",
  "what it is": "c'est quoi",
  "ask chi…": "demande à chi…",
  "ask": "demander",
  "refresh": "actualiser",
  "find a task": "trouver une tâche",
  "just type, it saves itself": "écris juste, ça s'enregistre tout seul",
  "search notes": "chercher des notes",
  "back": "retour",
  "print": "imprimer",
  "# heading\n\nmarkdown works, autosave is on": "# titre\n\nmarkdown fonctionne, enregistrement auto activé",
  "search refs, tags, characters": "chercher des réfs, tags, personnages",
  "tile size": "taille des vignettes",
  "add pictures": "ajouter des images",
  "sort the feed": "trier le fil",
  "what you want to remember about this": "ce que tu veux te rappeler à propos de ça",
  "re-index": "réindexer",
  "open post": "ouvrir la publication",
  "message chi": "écrire à chi",
  "send": "envoyer",
  "a sketch a day…": "un croquis par jour…",
  "how often": "à quelle fréquence",
  "how many": "combien",
  "note, optional": "note, facultatif",
  "nudge me about…": "rappelle-moi de…",
  "kind": "genre",
  "set the time": "régler l'heure",
  "minutes, like 40 or 1h30": "minutes, comme 40 ou 1h30",
  "reset": "réinitialiser",
  "another tip": "un autre truc",
  "pick a colour": "choisis une couleur",
  "name, like sitting nsfw": "nom, comme assise nsfw",
  "piece": "pièce",
  "client (for the money stats)": "client (pour les stats d'argent)",
  "amount": "montant",
  "due": "échéance",
  "what they want drawn": "ce qu'ils veulent qu'on dessine",
  "previous month": "mois précédent",
  "next month": "mois suivant",
  "what is it": "c'est quoi",
  "owed": "dû",
  "category": "catégorie",
  "only refs matching… (optional)": "seulement les réfs qui correspondent… (facultatif)",
  "add the characters from zirk.eu/oc": "ajouter les personnages de zirk.eu/oc",
  "add the characters from the discord character channel": "ajouter les personnages du canal de personnages discord",
  "chi looks at character pictures and writes tags and a line about each, so she picks better characters and refs": "chi regarde les images de personnages et écrit des tags et une ligne sur chacun, pour mieux choisir les personnages et les réfs",
  "search name, race, likes, fetishes…": "chercher nom, race, goûts, fétiches…",
  "search characters…": "chercher des personnages…",
  "reload": "recharger",
  "add an event": "ajouter un événement",
  "map": "carte",
  "name it: studio, mum's, good parking": "donne-lui un nom : studio, chez maman, bon stationnement",
  "a note, optional": "une note, facultatif",
  "colour": "couleur",
  "sushi, art supplies, an address": "sushis, matériel d'art, une adresse",
  "how far": "à quelle distance",
  "add a stop: address, postcode or place": "ajoute un arrêt : adresse, code postal ou lieu",
  "add stop": "ajouter un arrêt",
  "download": "télécharger",
  "add the picture on your clipboard, or press ctrl+v": "ajoute l'image du presse-papiers, ou appuie sur ctrl+v",
  "search title, artist, character, tag…": "chercher titre, artiste, personnage, tag…",
  "untitled": "sans titre",
  "type a name to add a character": "écris un nom pour ajouter un personnage",
  "count a fap": "compter un fap",
  "console.anthropic.com, api keys": "console.anthropic.com, clés d'api",
  "the part after the domain": "la partie après le domaine",
  "maps javascript, places (new) and routes": "maps javascript, places (new) et routes",
  "only if the map should load with its own key": "seulement si la carte doit se charger avec sa propre clé",
  "find a tool or place": "trouve un outil ou un lieu",
  "what needs doing?": "qu'est-ce qu'il y a à faire?",
  "optional notes": "notes facultatives",
  "index": "index",
  "mark done": "marquer comme fait",
  "status": "statut",
  "link a task": "lier une tâche",
  "find a plane or chix task": "trouve une tâche plane ou chix",
  "take back the last one": "annuler le dernier",
  "take out": "retirer",
  "tasks": "tâches",
  "Today": "Aujourd'hui",
  "References": "Références",
  "describe": "décrire",
  "Ask ChiX": "Demande à ChiX",
  "gesture": "geste",
  "Gesture drawing": "Dessin gestuel",
  "Session timer": "Minuterie de séance",
  "palette": "palette",
  "Commissions": "Commandes",
  "maps": "cartes",
  "Calculator": "Calculatrice",
  "doodles": "griffonnages",
  "scans": "numérisations",
  "Claude usage": "Utilisation de Claude",
  "people": "personnes",
  "share": "partager",
  "setup": "réglages",
  "keys": "clés",
  "themes": "thèmes",
  "studio": "studio",
  "system": "système",
  "Home": "Accueil",
  "Studio": "Studio",
  "Practice": "Pratique",
  "Ledger": "Comptes",
  "Library": "Bibliothèque",
  "Core": "Noyau",
  "language": "langue",
  "yours only. the app's words and chi's replies follow it. it saves as soon as you pick": "juste à toi. les textes de l'app et les réponses de chi la suivent. ça s'enregistre dès que tu choisis",
  "Quick note": "Note rapide",
  "Reminders": "Rappels",
  "Ubuntu helpers": "Outils Ubuntu",
  "Quit": "Quitter",
  "open {name}": "ouvrir {name}",
  "sort": "tri",
  "this one is mine": "celui-là est à moi",
  "reverse the order": "inverser l'ordre",
  "filter": "filtre",
  "{name} can sign in now. they start with chi, notes, pings, routines and goals": "{name} peut se connecter maintenant. iel commence avec chi, les notes, les rappels, les routines et les objectifs",
  "retro": "rétro",
  "pin": "épingle",
  "no": "non",
  "fps": "i/s",
  "drama": "drame",
  "Refs": "Réfs",
  "info": "infos",
  "refs": "réfs",
  "feed": "fil"
};
